export type AccessBadgeLabels = {
    hostSingular: string;
    accountSingular: string;
    organizationSingular: string;
};

export type HostAccessBadge = {
    label: string;
    variant: 'success' | 'danger';
};

/**
 * Maps a host row's effective-access cascade (from the game_hosts_with_access
 * view) to a badge label + variant. `access_status` is one of: active,
 * host_inactive, account_inactive, account_expired, org_inactive, org_expired.
 * Labels swap with the account type (School/District vs Tier 2/Tier 1).
 */
export function hostAccessBadge(
    record: { access_status?: string | null; effective_active?: boolean | null },
    labels: AccessBadgeLabels,
): HostAccessBadge {
    const status = record.access_status ?? 'active';
    const map: Record<string, string> = {
        active: 'Active',
        host_inactive: `${labels.hostSingular} inactive`,
        account_inactive: `${labels.accountSingular} inactive`,
        account_expired: `${labels.accountSingular} expired`,
        org_inactive: `${labels.organizationSingular} inactive`,
        org_expired: `${labels.organizationSingular} expired`,
    };
    return {
        label: map[status] ?? status,
        variant: record.effective_active ? 'success' : 'danger',
    };
}
